import { QuestControlProps } from './index'
import { uniqueId } from 'lodash-es'
import React, { useRef } from 'react'
import classNames from 'classnames'

interface Props extends QuestControlProps<string> {
  disabled?: boolean
  onBlur?: () => void
}

const QuestTextControl = ({
  value,
  onChange,
  disabled = false,
  onBlur
}: Props) => {
  const id = useRef<string>(uniqueId('text-field'))

  const [isFocused, setIsFocused] = React.useState(false)

  const handleFocus = (): void => {
    setIsFocused(true)
  }

  const handleBlur = (): void => {
    setIsFocused(false)
  }

  return (
    <div className={'text-field'}>
      <div className="text-field__input">
        <>
          <label
            htmlFor={id.current}
            className={classNames({ _active: isFocused || value })}
          >
            Ваш ответ
          </label>
          <input
            readOnly={disabled}
            value={value}
            id={id.current}
            type={'text'}
            onFocus={handleFocus}
            onChange={(e) => {
              onChange?.(e.target.value)
            }}
            onBlur={(e) => {
              onChange?.(e.target.value.trim())
              handleBlur()
              onBlur?.()
            }}
          ></input>
        </>
      </div>
    </div>
  )
}

export { QuestTextControl }
